import React, { useState, useEffect } from "react";
import {
  Button,
  Col,
  Input,
  Row,
  Table,
  Popover,
  Dropdown,
  Modal,
  DatePicker,
} from "antd";
import {
  SearchOutlined,
  DownloadOutlined,
  CloseOutlined,
  FilterOutlined,
  CopyOutlined,
  CalendarOutlined,
} from "@ant-design/icons";
import COLORS from "../../../common/Colors";
import styled from "styled-components";
import UsersStyle from "../Users/style";
import ViewCourse from "./ViewCourse";
// Same plain pencil/trash icons used elsewhere (Dashboard to-dos,
// Certificate.js) instead of antd's FormOutlined/DeleteOutlined, which
// don't match the design's icon shapes.
// import { ReactComponent as EditPencil } from "../../../assets/Images/Edit_Pencil_01.svg";
// import { ReactComponent as TrashFull } from "../../../assets/Images/Trash_Full.svg";
import CourseStyle from "./style";
import moment from "moment";
import { useNavigate, useLocation } from "react-router-dom";
import { type } from "@testing-library/user-event/dist/type";
import { connect, useSelector } from "react-redux";
import FetchData from "../../../hooks/FetchData";
import PostUpdateData from "../../../hooks/postUpdate";
import { message } from "antd";
import { ReactComponent as Clone } from "../../../assets/clone.svg";
import { ReactComponent as EditPencil } from "../../../assets/Edit_Pencil_01.svg";
import { ReactComponent as Delete } from "../../../assets/delete.svg";
import { ReactComponent as Tick } from "../../../assets/Icons/tick.svg";



const StyledTable = styled(Table)`
  padding-top: 20px;
  table {
    width: 100% !important;
    font-family: "DM Sans", sans-serif;
  }
  .ant-table-content {
    overflow-x: auto;
    white-space: nowrap;
    border: 1px solid #00000024;
    border-radius: 8px;
  }
  .ant-table-cell {
    padding: 20px;
    color: #636980;
    font-family: "DM Sans", sans-serif;
  }
  .normal-column {
    min-width: 300px;
    white-space: normal;
  }
  .ant-table-thead {
    font-family: "DM Sans", sans-serif;
    font-weight: 500;
    // font-size: 0.9rem;
    width: 68px;
    height: 26px;
    color: #1F243B;
    white-space: nowrap;

  }
  .non-white {
    background: #f9f9f9;
  }
  .ant-table-thead > tr > th::before {
    display: none !important;
  }

  .ant-table-cell-row-hover {
    background: transparent !important;
  }

  // Hidden until the row is interacted with, instead of every row's
  // actions sitting visible all the time.
  .table_action_icons {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 16px;
    opacity: 0;
    transition: opacity 0.15s ease;
  }

  .ant-table-tbody > tr:hover .table_action_icons {
    opacity: 1;
  }

  // Plain colored icons, no circular badge background and no red-for-
  // delete distinction - the design shows clone/edit/delete as the same
  // teal, just sitting on the row. editIcon/deleteIcon are inline SVGs
  // (currentColor stroke) so this color actually reaches them; cloneIcon
  // is an antd font icon, which already respects CSS color.
  .cloneIcon,
  .editIcon,
  .deleteIcon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    font-size: 18px;
    color: #2bb791;
  }

  .editIcon,
  .deleteIcon {
    width: 20px;
    height: 20px;
  }

  .ellipsisIcon {
    color: #636980;
    cursor: pointer;
    font-size: 16px;
  }

`;

// Modal renders via a portal, and its content is not a DOM descendant of
// StyledTable (it's a JSX sibling, not nested inside the Table) - so
// styles scoped under StyledTable's generated class never reached it even
// with getContainer={false}. This wraps the modal's own content in its
// own scope instead, which works regardless of where the portal lands.
// Purpose-built instead of reusing AccountSeetting's AccountStyle, which
// carried a "you cannot undo this / don't ask again" layout this design
// doesn't have and put Delete before Cancel.
const DeleteModalContent = styled.div`
  .delete-modal-title {
    margin: 0;
    font-size: 20px;
    font-weight: 600;
    color: #1f243b;
    text-align: left;
  }

  .delete-modal-body {
    margin: 20px 0 28px;
    font-size: 16px;
    color: #1f243b;
    text-align: left;
  }

  /* Duplicate popup: grey sentence, course name in dark. */
  .delete-modal-body.is-muted {
    color: #636980;
  }

  .delete-modal-body .course-name {
    color: #1f243b;
  }

  .delete-modal-footer {
    display: flex;
    justify-content: flex-end;
    gap: 16px;
  }

  .delete-modal-cancel,
  .delete-modal-confirm {
    min-width: 130px;
    height: 40px;
    border-radius: 8px;
    font-size: 16px;
    cursor: pointer;
  }

  .delete-modal-cancel {
    background: #ffffff;
    border: 1px solid #1f243b;
    color: #1f243b;
  }

  .delete-modal-confirm {
    background: #c2fae5;
    border: none;
    color: #1f243b;
  }

  .delete-modal-confirm:hover,
  .delete-modal-cancel:hover {
    background: #a9f2d8 !important;
    color: #1f243b !important;
    border-color: #1f243b !important;
  }
`;

const columnStyles = {
  height: "51px",
  padding: "15px 16px",
  gap: "10px",
  opacity: 1, 
};

const Course = () => {
  const [tableViewData, setTableViewData] = useState();
  const [userRenderView, setUserRenderView] = useState("table-view");
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);

  const [courseTableData, setCourseTableData] = useState([]);
  const [loadingCourses, setLoadingCourses] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  // Course waiting on the "Duplicate" confirmation (Figma: clone icon ->
  // Duplicate popup -> Cloned popup).
  const [duplicateTarget, setDuplicateTarget] = useState(null);
  // Name of the course just cloned - shows the "Cloned" popup.
  const [clonedCourseName, setClonedCourseName] = useState(null);
  const [filterValue, setFilterValue] = useState("");
  const [deleteData, setDeleteData] = useState({});
  const [searchText, setSearchText] = useState("");

  const navigate = useNavigate();
  const location = useLocation();
  const userInfo = useSelector((state) => state.authTracking.userInfo);

  const fetchCourses = async () => {
    if (!userInfo?.clientId) return;
    setLoadingCourses(true);
    try {
      const response = await FetchData({
        endPoint: `/course/getcourse/${userInfo.clientId}`,
      });
      setCourseTableData(response?.response || []);
    } catch (error) {
      console.error("Error fetching courses:", error);
      message.error("Unable to load courses");
    } finally {
      setLoadingCourses(false);
    }
  };

  useEffect(() => {
    fetchCourses();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userInfo?.clientId]);

  // Dashboard > Recent Activity links to a specific course (Course >
  // People tab) via navigate("/course", { state: { openCourseId } }) -
  // once the course list has loaded, jump straight into that course
  // instead of showing the list, then clear the nav state so refreshing
  // or navigating back here later doesn't keep re-opening it.
  useEffect(() => {
    const openCourseId = location.state?.openCourseId;
    if (!openCourseId || courseTableData.length === 0) return;
    const course = courseTableData.find((c) => c.course_id === openCourseId);
    if (course) {
      setUserRenderView("view-table");
      setTableViewData(course);
    }
    navigate(location.pathname, { replace: true, state: {} });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [courseTableData]);

  const create = () => {
    navigate('/CreateCourse');
  };

  const hanldeClickEdit = (record) => {
    navigate('/CreateCourse', { state: record });
  };

  const hanldeClickDeleteIcon = (record) => {
    setDeleteData(record);
    setDeleteModal(true);
  };

  const hanldeClickDelete = async () => {
    try {
      const response = await PostUpdateData({
        endPoint: `/course/deletecourse/${userInfo.clientId}/${deleteData.course_id}`,
        method: "DELETE",
      });
      if (response?.status === 200 || response?.statusCode === 200) {
        message.success("Course deleted successfully");
        setDeleteModal(false);
        fetchCourses();
      } else {
        message.error("Something went wrong while deleting the course");
      }
    } catch (error) {
      console.error("Error deleting course:", error);
      // A 409 (course still assigned to a group, etc.) carries a specific,
      // actionable message from the backend - show that instead of the
      // generic fallback so the admin knows what to actually do.
      const specificMessage = error?.response?.data?.message;
      message.error(specificMessage || "Something went wrong while deleting the course");
    }
  };

  const handleClone = async (record) => {
    // Extract the base course name without any "(number)"
    const baseCourseName = (record.course_name || "").replace(/\(\d+\)$/, "").trim();

    // Count how many existing clones already use this base name
    const existingClones = courseTableData.filter((item) =>
      (item.course_name || "").startsWith(baseCourseName)
    );

    // Determine the next clone number
    const nextCloneNumber = existingClones.length;

    try {
      const response = await PostUpdateData({
        endPoint: `/course/addcourse/${userInfo.clientId}`,
        method: "POST",
        obj: {
          ...record,
          course_id: undefined,
          course_name: `${baseCourseName}(${nextCloneNumber})`,
          // units comes back from GET already parsed into a real array of
          // objects; `units` is a jsonb[] column, so each element needs to
          // be re-stringified before going back out or Postgres can't
          // parse it as jsonb.
          units: (record.units || []).map((unit) => JSON.stringify(unit)),
        },
      });
      if (response?.statusCode === 201) {
        // Same tick popup as Create Course's "Published", closes itself.
        setClonedCourseName(`${baseCourseName}(${nextCloneNumber})`);
        setTimeout(() => setClonedCourseName(null), 1500);
        fetchCourses();
      } else {
        message.error("Something went wrong while cloning the course");
      }
    } catch (error) {
      console.error("Error cloning course:", error);
      message.error("Something went wrong while cloning the course");
    }
  };
  const columns1 = [
    {
      title: "Code",
      dataIndex: "course_code",
      key: "course_code",
      width: 124,
      onHeaderCell: () => ({
        style: columnStyles, // Apply shared styles to the header cell
      }),
      onCell: () => ({
        style: columnStyles, // Apply shared styles to the data cells
      }),
    },
    {
      title: "Course Title",
      dataIndex: "course_name",
      key: "course_name",
      width: 233.25,
      onHeaderCell: () => ({
        style: columnStyles, // Apply shared styles to the header cell
      }),
      onCell: () => ({
        style: columnStyles, // Apply shared styles to the data cells
      }),
    },
    {
      title: "Category",
      dataIndex: "category",
      key: "category",
      width: 233.25,
      onHeaderCell: () => ({
        style: columnStyles, // Apply shared styles to the header cell
      }),
      onCell: () => ({
        style: columnStyles, // Apply shared styles to the data cells
      }),
    },
    {
      title: "Price",
      dataIndex: "price",
      key: "price",
      width: 233.25,
      onHeaderCell: () => ({
        style: columnStyles, // Apply shared styles to the header cell
      }),
      onCell: () => ({
        style: columnStyles, // Apply shared styles to the data cells
      }),
    },
    {
      title: "Last Updated on",
      dataIndex: "updated_at",
      key: "updated_at",
      render: (text) => {
        const date = moment(text);
        return date.isValid() ? date.format("Do MMM YYYY; hh:mm A") : "-";
      },
      width: 233.25,
      onHeaderCell: () => ({
        style: columnStyles, // Apply shared styles to the header cell
      }),
      onCell: () => ({
        style: columnStyles, // Apply shared styles to the data cells
      }),
      
    },
    {
      title: "",
      dataIndex: "edit",
      key: "edit",
      width: 244,

      render: (text, record) => {
        return (
          <div className="table_action_icons">
            <Popover placement="top" content="Clone">
              <Clone
                className="cloneIcon"
                onClick={(e) => {
                  e.stopPropagation();
                  setDuplicateTarget(record);
                }}
              />
            </Popover>
            <Popover placement="top" content="Edit">
              <EditPencil
                className="editIcon"
                onClick={(e) => {
                  e.stopPropagation();
                  hanldeClickEdit(record);
                }}
              />
            </Popover>
            <Popover placement="top" content="Delete">
              <Delete
                className="deleteIcon"
                onClick={(e) => {
                  e.stopPropagation();
                  hanldeClickDeleteIcon(record);
                }}
              />
            </Popover>
          </div>
        );
      },
    },
  ];

  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const onChangeSortedTable = (pagination, filters, sorter, extra) => {
    console.log("params", pagination, filters, sorter, extra);
  };

  const handleClickData = (data) => {
    setUserRenderView("view-table");
    setTableViewData(data);
  };

  const items = [
    {
      label: "Active",
      key: "active", // Adding a key for better item identification
    },
    {
      label: "InActive",
      key: "inactive",
    },
  ];

  const handleClickFilter = (data) => {
    setFilterValue(data.label);
  };
  return (
    <>
      <UsersStyle>
        {userRenderView === "table-view" ? (
          <>
            <div className="user-title-container">
              <p className="user-menu-title">Course</p>
              <button className="create-course-button" style={{marginTop:"0px"}} onClick={create}>
                + Create Course
              </button>
            </div>
            <br></br>
            <CourseStyle>
              <Row className="users-menu-filter-container">
                <Col className="course_filter_section_with_icon">
                  <div className="total-course-header">
                    <div className="total-course-left">
                      Total Course Created: {courseTableData.length}
                    </div>
                    <div className="total-course-right">
                      <Input
                        className="search-label"
                        prefix={<SearchOutlined />}
                        placeholder="Search"
                        value={searchText}
                        onChange={(e) => setSearchText(e.target.value)}
                        allowClear
                      />
                      {/* Figma puts the calendar icon before "Date",
                          not antd's default trailing suffix icon. */}
                      <DatePicker
                        className="date-label"
                        format="DD/MM/YYYY"
                        placeholder="Date"
                        prefix={<CalendarOutlined style={{ color: "#636980" }} />}
                        suffixIcon={null}
                      ></DatePicker>
                    </div>
                  </div>
                  {/* <Form.Item name="search" className="search-input-field">
                    <Input prefix={<SearchOutlined />} placeholder="Search" />
                  </Form.Item> */}

                  {/* <Dropdown
                    menu={{
                      items,
                      onClick: ({ key, domEvent }) => {
                        // Find the clicked item based on the key
                        const clickedItem = items.find(
                          (item) => item.key === key
                        );
                        handleClickFilter(clickedItem);
                      },
                    }}
                    title="Status"
                    trigger={["click"]}
                  >
                    <Popover placement="top" content="Filters">
                      <div className="filter_icon_box">
                        <FilterOutlined />
                      </div>
                    </Popover>
                  </Dropdown> */}

                  {/* {filterValue && (
                    <Button className="active_filter_button">
                      <CloseOutlined onClick={() => setFilterValue("")} />{" "}
                      {filterValue}
                    </Button>
                  )} */}
                </Col>

                {/* <Col>
                  <Button className="add-user-button">Add Course</Button>
                </Col> */}
              </Row>
            </CourseStyle>
            <StyledTable
              // rowSelection={rowSelection}
              dataSource={courseTableData.filter((item) => {
                const search = searchText.trim().toLowerCase();
                if (!search) return true;
                return (
                  item.course_name?.toLowerCase().includes(search) ||
                  item.course_code?.toLowerCase().includes(search) ||
                  item.category?.toLowerCase().includes(search)
                );
              })}
              columns={columns1}
              loading={loadingCourses}
              rowClassName={(record, index) =>
                index % 2 === 0 ? "" : "non-white"
              }
              rowKey="course_id"
              id="Table"
              onChange={onChangeSortedTable}
              showSorterTooltip={{
                target: "sorter-icon",
              }}
              onRow={(record) => ({
                onClick: () => handleClickData(record),
              })}
            />
          </>
        ) : (
          <ViewCourse
            tableViewData={tableViewData}
            setUserRenderView={setUserRenderView}
          />
        )}

        <Modal
          open={!!duplicateTarget}
          footer={false}
          closable={false}
          centered
          width={480}
          onCancel={() => setDuplicateTarget(null)}
        >
          <DeleteModalContent>
            <p className="delete-modal-title">Duplicate</p>
            <p className="delete-modal-body is-muted">
              Are you sure you want to duplicate the course{" "}
              <span className="course-name">
                &ldquo;{duplicateTarget?.course_name}&rdquo;
              </span>
              ?
            </p>
            <div className="delete-modal-footer">
              <button
                type="button"
                className="delete-modal-cancel"
                onClick={() => setDuplicateTarget(null)}
              >
                Cancel
              </button>
              <button
                type="button"
                className="delete-modal-confirm"
                onClick={() => {
                  const record = duplicateTarget;
                  setDuplicateTarget(null);
                  handleClone(record);
                }}
              >
                Duplicate
              </button>
            </div>
          </DeleteModalContent>
        </Modal>

        <Modal
          open={!!clonedCourseName}
          footer={null}
          centered
          closable={false}
          width={198}
          onCancel={() => setClonedCourseName(null)}
        >
          <div style={{ display: "flex", flexDirection: "column", alignItems: "center", textAlign: "center" }}>
            <Tick style={{ width: "34px", height: "34px" }} />
            <p style={{ fontSize: "16px", fontWeight: 400, margin: "8px 0 0" }}>Cloned</p>
            <p style={{ fontSize: "13px", color: "#636980", margin: "4px 0 0", wordBreak: "break-word" }}>
              {clonedCourseName}
            </p>
          </div>
        </Modal>

        <Modal
          open={deleteModal}
          footer={false}
          closable={false}
          centered
          width={480}
          onCancel={() => setDeleteModal(false)}
        >
          <DeleteModalContent>
            <p className="delete-modal-title">Delete</p>
            <p className="delete-modal-body">
              Are you sure you want to delete this course?
            </p>
            <div className="delete-modal-footer">
              <button
                type="button"
                className="delete-modal-cancel"
                onClick={() => setDeleteModal(false)}
              >
                Cancel
              </button>
              <button
                type="button"
                className="delete-modal-confirm"
                onClick={hanldeClickDelete}
              >
                Delete
              </button>
            </div>
          </DeleteModalContent>
        </Modal>
      </UsersStyle>
    </>
  );
}

export default(Course);
